<template>
  <div class="progressWrapper">
    <progress
      class="progress"
      :class="[classes]"
      :value="value"
      :max="max">
      {{ valueHuman }}
    </progress>
    <div
      v-if="displayValue"
      class="progressWrapper-displayValue">
      <span>{{ valueHuman }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgramProgressBar',
  components: {},
  mixins: [],
  props: {
    classes: {
      type: String,
      required: false,
      default: 'is-success'
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    valueHuman: {
      type: String,
      required: false,
      default: ''
    },
    displayValue: {
      type: Boolean,
      required: false,
      default: false
    },
    max: {
      type: Number,
      required: false,
      default: 100
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {}
}
</script>
